export const PROJECT_MOVE_RESOURCE_MODAL = 'projectMoveResourceModal';
